// ABOUTME: Renders the icon for a scope level (salesOrg, dispatchGr, plant, customer).
// ABOUTME: Used in ScopeNavigator and FindScopeModal to avoid repeating the lookup pattern.
import {Icon} from '@hm/fundamental'
import React from 'react'

import {ScopeLevel} from '../types'
import {SCOPE_LEVEL_OPTIONS} from '../utils'

interface ScopeLevelIconProps {
  level?: ScopeLevel
  className?: string
}

export const ScopeLevelIcon = ({level, className = ''}: ScopeLevelIconProps) => {
  if (!level) return null
  const option = SCOPE_LEVEL_OPTIONS.find((o) => o.value === level)
  if (!option) return null
  return (
    <Icon
      path={option.icon}
      size="regular"
      className={`shrink-0 ${option.iconClassName} ${className}`.trim()}
    />
  )
}
